"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _LoginFormComponent = _interopRequireDefault(require("./LoginFormComponent"));
var _authActions = require("../../redux/actions/authActions");
var _path = _interopRequireDefault(require("../../helpers/path"));
var _reactRouter = require("react-router");
var _config = _interopRequireDefault(require("../../config"));
var _wsHelper = require("../../helpers/wsHelper");
var _apex = require("../../apex");
var _wsConnectionActions = require("../../redux/actions/wsConnectionActions");
var _appActions = require("../../redux/actions/appActions");
var _lifeCycleActions = require("../../redux/actions/lifeCycleActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var globalSiteName = _config["default"].global.siteName,
  LoginForm = _config["default"].LoginForm,
  _config$SignupForm = _config["default"].SignupForm,
  useEmailAsUsername = _config$SignupForm.useEmailAsUsername,
  active = _config$SignupForm.active;
var gateway = (0, _wsHelper.getLoginFormGateway)();
var siteName = LoginForm && LoginForm.siteName ? LoginForm.siteName : globalSiteName;
var mapStateToProps = function mapStateToProps(state) {
  var _state$auth$errorMsg;
  return {
    errorMsg: useEmailAsUsername ? (_state$auth$errorMsg = state.auth.errorMsg) === null || _state$auth$errorMsg === void 0 ? void 0 : _state$auth$errorMsg.replace('username', 'email') : state.auth.errorMsg,
    isConnected: state.wsConnection.isConnected,
    useEmailAsUsername: useEmailAsUsername,
    active: active,
    siteName: siteName,
    gateway: gateway,
    formGateway: (0, _reduxForm.formValueSelector)('login')(state, 'gateway')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    resetForm: function resetForm() {
      return dispatch((0, _reduxForm.change)('login', 'gateway', ''));
    },
    doSubmit: function doSubmit(payload, isConnected) {
      if (!isConnected || !navigator.onLine) {
        (0, _apex.setGateway)(payload.gateway);
        localStorage.setItem('tradingServer', payload.gateway);
        (0, _apex.initApex)(function () {
          dispatch((0, _authActions.login)(payload)).then(function (action) {
            dispatch((0, _wsConnectionActions.connectionClosedCount)(0));
            dispatch((0, _appActions.loadStartupData)());
            dispatch((0, _lifeCycleActions.onInit)());
            if (action.type === _authActions.ENABLE_2FA_REQUIRED) {
              ownProps.history.push((0, _path["default"])('/enabletwofactorauth'));
            } else if (action.type === _authActions.AUTH_2FA_REQUIRED) {
              ownProps.history.push((0, _path["default"])('/twofactorauth'));
            }
          });
        }, function () {
          return dispatch((0, _wsConnectionActions.connectionClosed)());
        });
        return;
      }
      return dispatch((0, _authActions.login)(payload)).then(function (action) {
        if (action.type === _authActions.ENABLE_2FA_REQUIRED) {
          ownProps.history.push((0, _path["default"])('/enabletwofactorauth'));
        } else if (action.type === _authActions.AUTH_2FA_REQUIRED) {
          ownProps.history.push((0, _path["default"])('/twofactorauth'));
        }
      });
    }
  };
};
var LoginFormContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_LoginFormComponent["default"]);
var LoginFormContainerForm = (0, _reduxForm.reduxForm)({
  form: 'login',
  onSubmit: function onSubmit() {}
})(LoginFormContainer);
var _default = exports["default"] = (0, _reactRouter.withRouter)(LoginFormContainerForm);